import { Controller } from '@hotwired/stimulus'

const csrfParamInput = () => {
  const csrfParamInput = document.createElement('input');
  csrfParamInput.type = 'hidden';
  csrfParamInput.name = document.querySelector('meta[name=csrf-param]').content;
  csrfParamInput.value = document.querySelector('meta[name=csrf-token]').content;
  return csrfParamInput;
}

const methodInput = (method) => {
  const methodInput = document.createElement('input');
  methodInput.type = 'hidden';
  methodInput.name = '_method';
  methodInput.value = method || 'post';
  return methodInput;
}

// This controller is used to submit a form with a prompt.
// It is used for example to create or update a model with just one field,
// Examples: rename a resource, create a blank resource, clone with name, create a folder, etc.

// Connects to data-controller="components--prompt-submit"
export default class extends Controller {
  connect() {
    this.promptClickHandler = () => {
      const promptText = this.element.dataset.prompt
      const fieldPath = this.element.dataset.field // e.g. 'room[name]'
      const input = prompt(promptText)

      if (input === null || !fieldPath) {
        event.preventDefault()
        return
      }

      const [object, attribute] = fieldPath.match(/([^\[]+)\[([^\]]+)\]/).slice(1, 3)

      // Add or update hidden input
      let inputField = this.element.querySelector(`input[name="${object}[${attribute}]"]`)
      if (!inputField) {
        inputField = document.createElement('input')
        inputField.type = 'hidden'
        inputField.name = `${object}[${attribute}]`
        this.element.appendChild(inputField)
      }

      inputField.value = input
    }

    this.element.addEventListener('click', this.promptClickHandler)
  }

  disconnect() {
    // Remove the event listener when the element is disconnected
    this.element.removeEventListener('click', this.promptClickHandler)
  }
}
